// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoDismissController from "./auto_dismiss_controller"
application.register("auto-dismiss", AutoDismissController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import LyricsController from "./lyrics_controller"
application.register("lyrics", LyricsController)

import MobileSideNavController from "./mobile_side_nav_controller"
application.register("mobile-side-nav", MobileSideNavController)

import PackageSelectionController from "./package_selection_controller"
application.register("package-selection", PackageSelectionController)
